import * as React from "react";

function SvgIcons8Server(props, ref) {
  return (
    <svg
      id="icons8-server_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 144.6 77.4"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".icons8-server_svg__st1{fill:#6474a6}.icons8-server_svg__st6{fill:#1f212b}"
        }
      </style>
      <path
        d="M139.6 60.1h-25.4c-2 0-3.6-1.6-3.6-3.6V4.9c0-2 1.6-3.6 3.6-3.6h25.4c2 0 3.6 1.6 3.6 3.6v51.6c.1 2-1.5 3.6-3.6 3.6z"
        fill="#b3b2c3"
      />
      <path
        className="icons8-server_svg__st1"
        d="M120.7 6.6h18.7v4.1h-24.9V6.6h1.6"
      />
      <path
        d="M126.9 52.7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.6-1.5-1.5-1.5z"
        fill="#f9e65c"
      />
      <path
        d="M126.9 42.6c-2.2 0-4.1 1.8-4.1 4.1s1.8 4.1 4.1 4.1c2.2 0 4.1-1.8 4.1-4.1s-1.8-4.1-4.1-4.1z"
        fill="#fef6aa"
      />
      <path
        className="icons8-server_svg__st1"
        d="M118.2 14.6h21.2v4.1h-24.9v-4.1h1.6m14.2 12.1h-15.8v-4.1h24.9v4.1h-1.6"
      />
      <path
        d="M127.1 69.8c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z"
        fill="#8f9eb6"
      />
      <path
        d="M125.4 60.6v2.6c0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7v-2.6h-3.4z"
        fill="#fae8e6"
      />
      <path
        className="icons8-server_svg__st6"
        d="M126.7 64.7V70c0 .1.2.2.3.2.2 0 .3-.1.3-.2v-5.3h-.6zM140 61h-25.7c-2.6 0-4.6-2.1-4.6-4.6V4.6c0-2.6 2.1-4.6 4.6-4.6H140c2.6 0 4.6 2.1 4.6 4.6v51.7c0 2.6-2.1 4.7-4.6 4.7zM114.3 2c-1.5 0-2.6 1.2-2.6 2.6v51.7c0 1.5 1.2 2.6 2.6 2.6H140c1.5 0 2.6-1.2 2.6-2.6V4.6c0-1.5-1.2-2.6-2.6-2.6h-25.7z"
      />
      <path
        className="icons8-server_svg__st6"
        d="M139.1 11h-25c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5h-1.5v3h24V7h-18.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h19c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5zm-12 45.2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm0-2c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5zm0-8c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.5-3.5-3.5-3.5zm12-24.2h-25c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5h-1.5v3h24v-3h-20.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h21c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5zm0 8h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.5v-3h-24v3h15.5c.3 0 .5.2.5.5s-.2.5-.5.5h-16c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h25c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5z"
      />
      <path
        className="icons8-server_svg__st6"
        d="M135.1 27h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5zM124.9 72.2h-13.6c-.3 0-.5.2-.5.4s.2.4.5.4H125c-.1-.3-.1-.5-.1-.8zm19.1 0h-14.5c0 .3-.1.5-.2.7H144c.3 0 .5-.2.5-.4 0-.1-.2-.3-.5-.3z"
      />
      <path
        className="icons8-server_svg__st6"
        d="M127.2 75.2c-1.6 0-2.9-1.3-2.9-3s1.3-3 2.9-3 2.9 1.3 2.9 3-1.3 3-2.9 3zm0-5c-1 0-1.9.9-1.9 2s.9 2 1.9 2c1 0 1.9-.9 1.9-2s-.9-2-1.9-2zM127.1 65.3c-1.4 0-2.5-1-2.5-2.2v-2.6c0-.3.2-.5.5-.5h4.1c.3 0 .5.2.5.5v2.6c0 1.3-1.2 2.2-2.6 2.2zm-1.5-4.2v2.1c0 .6.7 1.2 1.5 1.2s1.5-.5 1.5-1.2v-2.1h-3z"
      />
      <path d="M84.8 23.5l-.8.7 4.6 4.6H71.2c-.3 0-.6.2-.6.5s.2.6.5.6h17.4L84 34.5l.8.8 5.5-5.5.1-.1.3-.3-.3-.4-.1-.1-5.5-5.4zm-26.3 5.3c-.3 0-.6.2-.6.6s.2.6.6.6.6-.2.6-.6-.3-.6-.6-.6zm3.3 0c-.3 0-.6.2-.6.6s.2.6.6.6.6-.2.6-.6-.3-.6-.6-.6zm2.8 0c-.3 0-.6.2-.6.6s.2.6.6.6c.3 0 .6-.2.6-.6s-.3-.6-.6-.6zm2.2 0c-.3 0-.6.2-.6.6s.2.6.6.6c.3 0 .6-.2.6-.6s-.3-.6-.6-.6zm2.2 0c-.3 0-.6.2-.6.6s.2.6.6.6c.3 0 .6-.2.6-.6s-.3-.6-.6-.6zm-6.4 38.6c-2.4 0-4.4 1.7-4.9 4h-3.1c-.6 0-1 .4-1 1s.4 1 1 1h3.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4h4.2c.5 2.3 2.5 4 4.9 4 2.4 0 4.4-1.7 4.9-4h4.2c.5 2.3 2.5 4 4.9 4 2.4 0 4.4-1.7 4.9-4h3.1c.6 0 1-.4 1-1s-.4-1-1-1h-3.1c-.5-2.3-2.5-4-4.9-4-2.4 0-4.4 1.7-4.9 4h-4.2c-.5-2.3-2.5-4-4.9-4-2.4 0-4.4 1.7-4.9 4h-4.2c-.4-2.3-2.5-4-4.9-4zm0 2c1.6 0 2.9 1.3 3 2.9v.2c0 1.6-1.4 2.9-3 2.9s-2.9-1.3-3-2.9v-.2c.1-1.7 1.4-2.9 3-2.9zm14 0c1.6 0 2.9 1.3 3 2.9v.2c0 1.6-1.4 2.9-3 2.9s-2.9-1.3-3-2.9v-.2c.1-1.7 1.4-2.9 3-2.9zm14 0c1.6 0 2.9 1.3 3 2.9v.2c0 1.6-1.4 2.9-3 2.9s-2.9-1.3-3-2.9v-.2c.1-1.7 1.4-2.9 3-2.9zm-44 2c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm4 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm52 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm4 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z" />
      <path
        d="M37.7 58.6H6.4c-2.7 0-4.9-2.2-4.9-4.9V9.6c0-2.7 2.2-4.9 4.9-4.9h26.5c5.4 0 9.8 4.4 9.8 9.8v39.2c-.1 2.7-2.3 4.9-5 4.9z"
        fill="#fff"
      />
      <path
        d="M17.2 47.8c-2.5 0-4.4-2-4.4-4.4V39c0-.5-.4-1-1-1-.8 0-1.5-.6-1.5-1.5 0-.8.6-1.5 1.5-1.5.5 0 1-.4 1-1v-4.4c0-2.5 2-4.4 4.4-4.4.8 0 1.5.6 1.5 1.5s-.6 1.5-1.5 1.5c-.8 0-1.5.6-1.5 1.5v4.4c0 .9-.3 1.8-.9 2.5.5.7.9 1.5.9 2.5v4.4c0 .8.6 1.5 1.5 1.5.8 0 1.5.6 1.5 1.5-.1.7-.7 1.3-1.5 1.3zm9.8 0c-.8 0-1.5-.6-1.5-1.5 0-.8.6-1.5 1.5-1.5s1.5-.6 1.5-1.5V39c0-.9.3-1.8.9-2.5-.5-.7-.9-1.5-.9-2.5v-4.4c0-.8-.6-1.5-1.5-1.5s-1.5-.6-1.5-1.5.6-1.5 1.5-1.5c2.5 0 4.4 2 4.4 4.4v4.4c0 .5.4 1 1 1 .8 0 1.5.6 1.5 1.5 0 .8-.6 1.5-1.5 1.5-.5 0-1 .4-1 1v4.4c0 2.6-2 4.5-4.4 4.5z"
        fill="#71c2ff"
      />
      <g>
        <path
          d="M5.4 60.1h31.3c4.3 0 7.4-2.7 7.4-6.4V20.9c0-.8-.6-1.5-1.5-1.5-.8 0-1.5.6-1.5 1.5v32.8c0 2.1-1.8 3.4-4.4 3.4H5.4c-.8 0-2.5-1.5-2.5-3.4V9.6c0-1.9 1.5-3.4 3.4-3.4h25v3.4c0 3.5 2.8 6.4 6.4 6.4h4.9c.6 0 1.1-.4 1.4-.9.1-.2.1-.4.1-.6v-.2c0-2.9-1.2-5.7-3.3-7.8-2.2-2.1-5-3.3-8-3.3H6.4C2.8 3.3 0 6.1 0 9.6v44.1c0 3.6 2.9 6.4 5.4 6.4zm35.6-47h-3.3c-1.9 0-3.4-1.5-3.4-3.4V6.3c1.7.3 3.2 1.1 4.4 2.3s2 2.8 2.3 4.5z"
          fill="#444b54"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Server);
